import React, { useContext, useEffect } from 'react';
import { useRouteInfoState } from '../../../../../../components/RouteInfo/Context/RouteInfo.context';

import { GlobalContext } from '../../../../../../store';

import { useTeeSheetCreatorState } from '../../Context/TeeSheetCreator.context';
import { TeamCard } from '../../../../../../components/TeamCard/TeamCard';

export const TeamSelector = () => {
  const {
    actions: {
      adminEventTeams: { get: getAdminEventTeams }
    },
    adminEventTeams
  } = useContext(GlobalContext);

  const { clubId, eventId } = useRouteInfoState();

  const { selectedTeams } = useTeeSheetCreatorState();

  useEffect(() => {
    getAdminEventTeams(clubId, eventId);
  }, [getAdminEventTeams, clubId, eventId]);

  const filteredTeams = adminEventTeams[Number(eventId)]
    ? adminEventTeams[Number(eventId)].filter(
        team => team.isValid && !selectedTeams.includes(team.id)
      )
    : [];

  return (
    <div className="left team-selector">
      {filteredTeams.length > 0 ? (
        filteredTeams.map(team => (
          <TeamCard key={team.id} team={team} context="teeListSelector" hideActions={true} />
        ))
      ) : (
        <p className="all-items-selected">All the teams have been assigned</p>
      )}
    </div>
  );
};
